export const SET_AUTO_BILLING_STORE = "SET_AUTO_BILLING_STORE";
export const SET_AUTO_BILLING_RESET = "SET_AUTO_BILLING_RESET";

// Lấy danh sách đã đăng ký Auto Billing
export const FETCH_AUTO_BILLING_LIST_REQUEST = "FETCH_AUTO_BILLING_LIST_REQUEST";
export const FETCH_AUTO_BILLING_LIST_SUCCESS = "FETCH_AUTO_BILLING_LIST_SUCCESS";
export const FETCH_AUTO_BILLING_LIST_FAILURE = "FETCH_AUTO_BILLING_LIST_FAILURE";

// Huỷ đăng ký Auto Billing
export const FETCH_AUTO_BILLING_DELETE_REQUEST = "FETCH_AUTO_BILLING_DELETE_REQUEST";
export const FETCH_AUTO_BILLING_DELETE_SUCCESS = "FETCH_AUTO_BILLING_DELETE_SUCCESS";
export const FETCH_AUTO_BILLING_DELETE_FAILURE = "FETCH_AUTO_BILLING_DELETE_FAILURE";

// Check hoá đơn đã đăng ký chưa
export const FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST = "FETCH_AUTO_BILLING_VALID_CUSTOMER_REQUEST";
export const FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS = "FETCH_AUTO_BILLING_VALID_CUSTOMER_SUCCESS";
export const FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE = "FETCH_AUTO_BILLING_VALID_CUSTOMER_FAILURE";

// Đăng ký
export const FETCH_AUTO_BILLING_CREATE_REQUEST = "FETCH_AUTO_BILLING_CREATE_REQUEST";
export const FETCH_AUTO_BILLING_CREATE_SUCCESS = "FETCH_AUTO_BILLING_CREATE_SUCCESS";
export const FETCH_AUTO_BILLING_CREATE_FAILURE = "FETCH_AUTO_BILLING_CREATE_FAILURE";

// Xác thực
export const FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST = "FETCH_AUTO_BILLING_AUTHORIZATION_KEY_REQUEST";
export const FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS = "FETCH_AUTO_BILLING_AUTHORIZATION_KEY_SUCCESS";
export const FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE = "FETCH_AUTO_BILLING_AUTHORIZATION_KEY_FAILURE";

// Lấy lịch sử giao dịch Auto Billing
export const FETCH_AUTO_BILLING_TRANSACTION_REQUEST = "FETCH_AUTO_BILLING_TRANSACTION_REQUEST";
export const FETCH_AUTO_BILLING_TRANSACTION_SUCCESS = "FETCH_AUTO_BILLING_TRANSACTION_SUCCESS";
export const FETCH_AUTO_BILLING_TRANSACTION_FAILURE = "FETCH_AUTO_BILLING_TRANSACTION_FAILURE";
